module.exports = __webpack_public_path__ + "media/images/filter-cad9fef2ac6f6996b65d8ef8d3bb759a.png";